export default __webpack_public_path__ + "static/media/landing.242fce53.jpg";